import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WorkGallery from './components/WorkGallery';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Clients from './components/Clients';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';


import DynamicHead from './components/DynamicHead';

function PageLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <WorkGallery />
        <About />
        <Services />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <DynamicHead />
        <div className="font-inter antialiased bg-white text-gray-900 selection:bg-green-200 selection:text-green-900">
          <Routes>
            <Route path="/" element={<HomePage />} />


            <Route path="/clientes" element={<PageLayout><Clients /></PageLayout>} />
            <Route path="/politica-privacidade" element={<PageLayout><PrivacyPolicy /></PageLayout>} />
            <Route path="/politica-cookies" element={<PageLayout><CookiePolicy /></PageLayout>} />
            <Route path="/termos-servico" element={<PageLayout><TermsOfService /></PageLayout>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;